import {useLocation} from "react-router";

import {appendQueryString, parseSearch} from "@pg-mono/request";
import {rpAppLink} from "@pg-mono/rp-routes";

import {Country} from "../../region/types/Country";
import {getOfferListSubFilterParsed} from "../helpers/friendly_offer_list/get_offer_list_sub_filter_parsed";
import {appendOfferListQuery} from "../helpers/offer_list_url/build_offer_list_url";
import {getCountryId} from "../list/helpers/sub_type/get_fetch_offer_list_subfilter_query";
import {useOfferListingParams} from "./use_offer_listing_params";

export function useOffersListUrl() {
    const {search} = useLocation();

    const {friendlySlug, offerListSubFilter, offerListSubType, abroadRegionSlug, country} = useOfferListingParams();

    const parsedSearch = parseSearch(search);
    const {_page, _sort, ...validSearch} = parsedSearch;

    if (friendlySlug && country && getCountryId(country) !== Country.POLAND) {
        return appendOfferListQuery(
            rpAppLink.offer.listFriendlyAbroad({
                friendlySlug,
                country,
                abroadRegionSlug
            }),
            validSearch
        );
    }

    if (friendlySlug && offerListSubFilter) {
        const subFilterQuery = getOfferListSubFilterParsed(offerListSubFilter);

        const query = {
            ...validSearch,
            ...subFilterQuery
        };

        return appendOfferListQuery(rpAppLink.offer.listFriendly({friendlySlug}), query);
    }

    if (friendlySlug && offerListSubType) {
        return appendOfferListQuery(
            rpAppLink.offer.listFriendlySubType({
                friendlySlug,
                offerListSubType
            }),
            validSearch
        );
    }

    if (friendlySlug) {
        return appendOfferListQuery(rpAppLink.offer.listFriendly({friendlySlug}), validSearch);
    }

    return appendQueryString(rpAppLink.offer.multiList(), validSearch);
}
import {useLocation} from "react-router";

import {appendQueryString, parseSearch} from "@pg-mono/request";
import {rpAppLink} from "@pg-mono/rp-routes";

import {Country} from "../../region/types/Country";
import {getOfferListSubFilterParsed} from "../helpers/friendly_offer_list/get_offer_list_sub_filter_parsed";
import {appendOfferListQuery} from "../helpers/offer_list_url/build_offer_list_url";
import {getCountryId} from "../list/helpers/sub_type/get_fetch_offer_list_subfilter_query";
import {useOfferListingParams} from "./use_offer_listing_params";

export function useOffersListUrl() {
    const {search} = useLocation();

    const {friendlySlug, offerListSubFilter, offerListSubType, abroadRegionSlug, country} = useOfferListingParams();

    const parsedSearch = parseSearch(search);
    const {_page, _sort, ...validSearch} = parsedSearch;

    if (friendlySlug && country && getCountryId(country) !== Country.POLAND) {
        return appendOfferListQuery(
            rpAppLink.offer.listFriendlyAbroad({
                friendlySlug,
                country,
                abroadRegionSlug
            }),
            validSearch
        );
    }

    if (friendlySlug && offerListSubFilter) {
        const subFilterQuery = getOfferListSubFilterParsed(offerListSubFilter);

        const query = {
            ...validSearch,
            ...subFilterQuery
        };

        return appendOfferListQuery(rpAppLink.offer.listFriendly({friendlySlug}), query);
    }

    if (friendlySlug && offerListSubType) {
        return appendOfferListQuery(
            rpAppLink.offer.listFriendlySubType({
                friendlySlug,
                offerListSubType
            }),
            validSearch
        );
    }

    if (friendlySlug) {
        return appendOfferListQuery(rpAppLink.offer.listFriendly({friendlySlug}), validSearch);
    }

    return appendQueryString(rpAppLink.offer.multiList(), validSearch);
}
